import { useState } from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { Add, Contracts as ContractsIcon } from "@dreamhub/designsystem/icons";
import LogoIconContainer from "@/components/ui/logo-icon-container";
import { IconButton } from "@/components/ui/icon-button";
import ExportMenu from "@/components/ui/export-menu";
import ContractsTable from "@/pages/contracts/ContractsTable/ContractsTable";
import CreateContractModal from "@/pages/contracts/components/CreateContractModal";
import { UserData } from "@/entities/users/types";
import { useExportButtonState } from "@/services/hooks/entities/useExportButtonState";

interface Props {
  userData: UserData;
}

const Contracts: React.FC<Props> = ({ userData }) => {
  const { t } = useTranslation();
  const [isCreateContractOpen, setIsCreateContractOpen] = useState(false);
  const {
    exportTo: exportContracts,
    isExporting: isExportingContracts,
    handleExportStateChange
  } = useExportButtonState();

  return (
    <div
      data-test="contracts-page"
      className="flex flex-col max-h-[calc(var(--app-content-h)-var(--table-bottom-space))] h-full"
    >
      <div className="flex justify-between p-4 pb-2 h-14">
        <div className="flex gap-[10px] items-center">
          <LogoIconContainer
            icon={<ContractsIcon />}
            index={-1}
            className="size-8 flex-shrink-0"
            iconSize="5"
          />
          <Text as="div" variant="lgSubtitleH1" className="p-1">
            {t("contracts.title")}
          </Text>
        </div>
        <div className="flex items-center gap-2">
          <ExportMenu
            label={t("export")}
            data-test="contracts-export-button"
            onExport={exportContracts}
            isExporting={isExportingContracts}
          />
          <IconButton
            data-test="contracts-create-button"
            onClick={() => setIsCreateContractOpen(true)}
            size="lg"
            aria-label={t("contracts.createModal.createNew")}
            title={t("contracts.createModal.createNew")}
          >
            <Add />
          </IconButton>
        </div>
      </div>
      <ContractsTable onExportStateChange={handleExportStateChange} />
      <CreateContractModal
        isOpen={isCreateContractOpen}
        setIsOpen={setIsCreateContractOpen}
        userData={userData}
      />
    </div>
  );
};

export default Contracts;
